export enum BulkListingStep {
    IMPORT_LISTINGS = 'IMPORT_LISTINGS',
    EDIT_LISTINGS = 'EDIT_LISTINGS',
    EXPIRY_DATE = 'EXPIRY_DATE',
}
